import React from 'react';

import Input from '../commons/component/input';
import Error, { hasNamedError } from '../commons/component/error';
import Button from '../commons/component/button';
import AempUserIcon from '../icons/aemp-user-icon';

import InputMask from '../commons/component/input-mask';
import Recaptcha from '../commons/component/captcha/recaptcha';

import config from '../generated/config';
import { getAddressByZipCode } from '../api/cep/get';
import { dispatchSubmitEvent } from './metrics';
import moveToFirstError from '../api/customer/move-to-first-error';
import Select from '../commons/component/select';
import Checkbox from '../commons/component/checkbox';
import InputNumber from '../commons/component/input-number';
import { dispatchMetric } from '../metrics';
import { getEventPayload } from '../metrics/metrics.selector';

const FORM_FIELDS = [
  'cnpj',
  'email',
  'zipCode',
  'address',
  'number',
  'additionalInfo',
  'reference',
  'neighborhood',
  'city',
  'state',
  'stateRegistry',
  'taxInfo',
  'nationalSimple',
  'buyerAlreadyRegistered'
];

export default class CadastroPjBillingAddressComponent extends React.Component {
  state = {
    isFormSubmitting: false,
    errors: {},
    billing: {
      zipCode: this.props.formDataState.zipCode || this.handleFormData('address', 'zipCode'),
      address: this.props.formDataState.address || this.handleFormData('address', 'publicPlace'),
      number: this.props.formDataState.number || this.handleFormData('address', 'number'),
      additionalInfo:
        this.props.formDataState.additionalInfo || this.handleFormData('address', 'complement'),
      neighborhood:
        this.props.formDataState.neighborhood || this.handleFormData('address', 'neighborhood'),
      city: this.props.formDataState.city || this.handleFormData('address', 'originalState'),
      state: this.props.formDataState.state || this.handleFormData('address', 'fu'),
      stateRegistry: this.props.formDataState.stateRegistry || this.getStateRegistration(),
      taxInfo: this.props.formDataState.taxInfo,
      email: this.props.formDataState.email,
      reference: this.props.formDataState.reference,
      nationalSimple: this.props.formDataState.nationalSimple
    },
    authorizeInfoShare: true
  };

  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  render() {
    const errors = this.state.errors;
    const {
      customerQualifyerData = {},
      goBackStep,
      goBackToFirstStep,
      currentStep,
      setCadastroPjDocumentState
    } = this.props;
    // const hasStateRegistry = this.getStateRegistration() !== '';

    return (
      <div>
        <div className="cadastroHeader">
          <h2 className="cadastroForm-title">
            <AempUserIcon />
            <span>cadastro</span>
          </h2>
          <p className="cadastroTitle">informações para faturamento</p>
          <p className="cadastroSubtitle">
            essas informações são importantes para realizarmos transações. enviaremos todas as
            informações de faturamento para o e-mail e o endereço cadastrado
          </p>
          {customerQualifyerData.success && (
            <strong>
              verifique se as informações preenchidas automaticamente estão corretas. em caso
              positivo, clique em 'continuar'.
            </strong>
          )}
        </div>

        <form className="cadastroForm" onSubmit={this.handleSubmit}>
          <div className="inputGroup --marginBottomMd" id="cnpj">
            <label className="inputGroup-label --acronym" htmlFor="cnpj-input">
              cnpj
            </label>
            <div className="addonWrapper">
              <InputNumber
                name="cnpj"
                id="cnpj-input"
                data-page="signup"
                data-form="signup"
                value={this.props.formDataState.cnpj}
                className={`inputGroup-input ${this.hasError('cnpj')}`}
                type="text"
                mask="__.___.___/____-__"
                placeholder="Ex: 12.345.678/1234-56"
                disabled
                required
              />
              <div className="inputText-addOn">
                <span
                  className="changeDocument"
                  onClick={() => goBackToFirstStep(setCadastroPjDocumentState)}
                >
                  trocar
                </span>
              </div>
            </div>
            <Error errors={errors} name="cnpj" />
          </div>
          <div className="inputGroup" id="email">
            <label className="inputGroup-label" htmlFor="email-input">
              e-mail para faturamento (nota fiscal)
            </label>
            <Input
              placeholder="Ex. joaodasilva@gmail.com"
              className={`inputGroup-input ${this.hasError('email')}`}
              data-page="signup"
              data-form="signup"
              name="email"
              onChange={this.changeField('email')}
              value={this.state.billing.email}
              id="email-input"
              type="email"
            />
            <Error errors={errors} name="email" />
          </div>
          <div className="inputGroup --halfSize" id="zipCode">
            <label className="inputGroup-label" htmlFor="zipCode-input">
              cep
            </label>
            <InputMask
              data-form="signup"
              data-page="signup"
              onChange={this.getCepOnChange}
              value={this.state.billing.zipCode}
              name="zipCode"
              id="zipCode-input"
              className={`inputGroup-input ${this.hasError('zipCode')}`}
              type="text"
              mask="_____-___"
              placeholder="Ex: 12345-678"
            />
            <Error errors={errors} name="zipCode" />
          </div>
          <div className="inputGroup" id="address">
            <label className="inputGroup-label" htmlFor="address-input">
              logradouro
            </label>
            <Input
              name="address"
              id="address-input"
              onChange={this.changeField('address')}
              value={this.state.billing.address}
              data-page="signup"
              data-form="signup"
              className={`inputGroup-input ${this.hasError('address')}`}
              type="text"
            />
            <Error errors={errors} name="address" />
          </div>
          <div className="groupRow">
            <div className="inputGroup" id="number">
              <label className="inputGroup-label" htmlFor="number-input">
                número
              </label>
              <Input
                name="number"
                id="number-input"
                onChange={this.changeField('number')}
                value={this.state.billing.number}
                data-page="signup"
                data-form="signup"
                className={`inputGroup-input ${this.hasError('number')}`}
                type="tel"
              />
              <Error errors={errors} name="number" />
            </div>
            <div className="inputGroup" id="additionalInfo">
              <label className="inputGroup-label" htmlFor="additionalInfo-input">
                complemento
              </label>
              <Input
                name="additionalInfo"
                id="additionalInfo-input"
                onChange={this.changeField('additionalInfo')}
                value={this.state.billing.additionalInfo}
                data-page="signup"
                data-form="signup"
                className={`inputGroup-input ${this.hasError('additionalInfo')}`}
                type="text"
                maxLength="47"
              />
              <Error errors={errors} name="additionalInfo" />
            </div>
          </div>
          <div className="groupRow">
            <div className="inputGroup" id="neighborhood">
              <label className="inputGroup-label" htmlFor="neighborhood-input">
                bairro
              </label>
              <Input
                name="neighborhood"
                id="neighborhood-input"
                onChange={this.changeField('neighborhood')}
                value={this.state.billing.neighborhood}
                data-page="signup"
                data-form="signup"
                className={`inputGroup-input ${this.hasError('neighborhood')}`}
                type="text"
              />
              <Error errors={errors} name="neighborhood" />
            </div>
            <div className="inputGroup" id="city">
              <label className="inputGroup-label" htmlFor="city-input">
                cidade
              </label>
              <Input
                name="city"
                id="city-input"
                onChange={this.changeField('city')}
                value={this.state.billing.city}
                data-page="signup"
                data-form="signup"
                className={`inputGroup-input ${this.hasError('city')}`}
                type="text"
              />
              <Error errors={errors} name="city" />
            </div>
          </div>
          <div className="groupRow">
            <div className="inputGroup" id="state">
              <label className="inputGroup-label" htmlFor="state-input">
                UF
              </label>
              <Input
                name="state"
                id="state-input"
                onChange={this.changeField('state')}
                value={this.state.billing.state}
                data-page="signup"
                data-form="signup"
                className={`inputGroup-input ${this.hasError('state')}`}
                type="text"
              />
              <Error errors={errors} name="state" />
            </div>
            <div className="inputGroup" id="reference">
              <label className="inputGroup-label" htmlFor="reference-input">
                referência do endereço
              </label>
              <Input
                name="reference"
                id="reference-input"
                onChange={this.changeField('reference')}
                value={this.state.billing.reference}
                data-page="signup"
                data-form="signup"
                className={`inputGroup-input ${this.hasError('reference')}`}
                type="text"
              />
              <Error errors={errors} name="reference" />
            </div>
          </div>
          <div className="inputGroup --halfSize" id="stateRegistry">
            <label className="inputGroup-label" htmlFor="stateRegistry-input">
              inscrição estadual
            </label>
            <InputNumber
              name="stateRegistry"
              id="stateRegistry-input"
              onChange={this.changeField('stateRegistry')}
              value={this.state.billing.stateRegistry}
              data-page="signup"
              data-form="signup"
              className={`inputGroup-input ${this.hasError('stateRegistry')}`}
              type="text"
              mask="____________________"
              disabled={this.state.billing.taxInfo === 'EXEMPT_TAXPAYER'}
            />
            <Error errors={errors} name="stateRegistry" />
          </div>
          <div className="taxes__wrapper">
            <div className="inputGroup" id="taxInfo">
              <label className="inputGroup-label">informações tributárias</label>
              <Select
                name="taxInfo"
                value={this.state.billing.taxInfo}
                onChange={this.changeField('taxInfo')}
                checked={this.state.billing.taxInfo}
                className={`inputGroup-input ${this.hasError('taxInfo')}`}
                options={{
                  TAXPAYER_ICMS: 'contribuinte ICMS',
                  NOT_TAXPAYER: 'não contribuinte ICMS',
                  EXEMPT_TAXPAYER: 'isento de inscrição estadual'
                }}
              />
              <Error errors={errors} name="taxInfo" />
            </div>
            <div className="inputGroup checkbox">
              <Checkbox
                className="inputGroup-checkbox"
                name="nationalSimple"
                onChange={this.changeField('nationalSimple')}
                checked={this.state.billing.nationalSimple}
                data-form="signup"
                data-page="signup"
                disabled={!(this.state.billing.taxInfo === 'TAXPAYER_ICMS')}
              >
                simples nacional
              </Checkbox>
            </div>
          </div>
          <div className="inputGroup --checkbox">
            <Checkbox
              className="inputGroup-checkbox"
              name="authorizeInfoShare"
              onChange={() =>
                this.setState({
                  authorizeInfoShare: !this.state.authorizeInfoShare
                })
              }
              checked={this.state.authorizeInfoShare}
              data-form="signup"
              data-page="signup"
            >
              Eu autorizo a americanas S.A e empresas parceiras a realizarem análise de crédito para
              oferecer as melhores formas de pagamento.
            </Checkbox>
          </div>
          {config.enableCaptchaOnPJRegister && <Recaptcha ref={ref => (this.captcha = ref)} />}

          <div className="cadastro-buttons">
            <Button
              primary
              disabled={this.state.isFormSubmitting || !this.state.authorizeInfoShare}
              loading={this.state.isFormSubmitting}
              className="cadastroForm-submit"
            >
              continuar
            </Button>
            <button
              className="btn button-ghost"
              disabled={this.state.isFormSubmitting}
              onClick={() => goBackStep(currentStep, setCadastroPjDocumentState)}
            >
              voltar
            </button>
          </div>
        </form>
      </div>
    );
  }

  getStateRegistration() {
    if (this.props.customerQualifyerData.success) {
      const registrations = this.props.customerQualifyerData.sintegraCompany.registrations || [];
      const activeRegistration = registrations.find(
        registration => registration.registrationStatus === 'HABILITADA'
      );
      if (activeRegistration) {
        return activeRegistration.sr || '';
      }
      return '';
    }
    return '';
  }

  handleFormData(father, son) {
    if (this.props.customerQualifyerData.success) {
      const emptyState = '';
      const fatherIsNotEmpty = !!this.props.customerQualifyerData[father];
      const handleData = this.props.customerQualifyerData[father][son] || emptyState;

      return fatherIsNotEmpty ? handleData : emptyState;
    }
  }

  getCepOnChange = async evt => {
    evt.preventDefault();
    const zipCode = evt.target.value;

    this.setState({
      billing: {
        ...this.state.billing,
        zipCode
      }
    });

    this.getCep(zipCode);
  };

  async getCep(zipCode) {
    if (zipCode.length === 9 && zipCode !== this.state.billing.zipCode) {
      this.setState({ isFormSubmitting: true });
      const { addressInfo, openAddressToEdit, errors } = await getAddressByZipCode(zipCode);

      dispatchSubmitEvent(this.state, errors);

      if (!addressInfo) {
        this.setState({ errors, isFormSubmitting: false });
        moveToFirstError(errors);
        return;
      }

      const { address, neighborhood, city, state, complement } = addressInfo;
      this.setState({
        billing: {
          ...this.state.billing,
          address,
          neighborhood,
          city,
          state,
          additionalInfo: complement
        },
        errors: {
          ...this.state.errors,
          ...errors
        },
        openAddressToEdit,
        isFormSubmitting: false
      });
    }
  }

  handleSubmit = async evt => {
    evt.preventDefault();
    this.setState({ isFormSubmitting: true });

    const { submitHandler, setCadastroPjDocumentState, currentStep, formDataState } = this.props;

    const eventType = 'event_signup';

    const metricPayload = {
      event: eventType,
      eventCategory: 'tela-cadastro-etapa-3',
      eventAction: 'continuar'
    };

    const metricEventPayload = getEventPayload({ ...metricPayload });

    try {
      await submitHandler(
        this.state.billing,
        FORM_FIELDS,
        this.captcha,
        formDataState,
        setCadastroPjDocumentState,
        currentStep
      );
      dispatchMetric(eventType, {
        payload: {
          eventLabel: 'sucesso',
          ...metricEventPayload
        }
      });
    } catch (errors) {
      dispatchMetric(eventType, {
        payload: {
          eventLabel: 'erro:campo-invalido',
          ...metricEventPayload
        }
      });
      this.setState({ errors, isFormSubmitting: false });
    }
  };

  hasError(name) {
    return hasNamedError(name, this.state.errors) ? '--hasError' : '';
  }

  changeField(name) {
    return e =>
      this.setState({
        billing: {
          ...this.state.billing,
          [name]: e.target.value
        }
      });
  }
}
